import getValueReduxUtil from 'modules/redux/utils/get-value'
import { TRAINING_PLAN_KEY } from 'modules/training/models/plan/constants'

function getWeeksCountPlanUtil (workout) {
  return getValueReduxUtil(
    workout, TRAINING_PLAN_KEY.WEEKS_COUNT
  )
}

export default getWeeksCountPlanUtil
